import { Injectable, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { WINDOW } from "../tokens";

@Injectable()
export class BrowserService {

    get viewportWidth(): number {
        return this.window.innerWidth || this.document.documentElement.clientWidth;
    }

    get viewportHeight(): number {
        return this.window.innerHeight || this.document.documentElement.clientHeight;
    }

    constructor(
        @Inject(WINDOW) private window: Window,
        @Inject(DOCUMENT) private document: Document
    ) { }

    copyTextToClipboard(text: string): boolean {
        if (text) {
            let textarea;
            let result;
            try {
                textarea = document.createElement('textarea');
                textarea.setAttribute('readonly', true);
                textarea.setAttribute('contenteditable', true);
                textarea.style.position = 'fixed'; // prevent scroll from jumping to the bottom when focus is set.
                textarea.value = text;
            
                document.body.appendChild(textarea);
            
                textarea.focus();
                textarea.select();
            
                const range = document.createRange();
                range.selectNodeContents(textarea);
            
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            
                textarea.setSelectionRange(0, textarea.value.length);
                result = document.execCommand('copy');
              } catch (err) {
                console.error(err);
                result = null;
              } finally {
                document.body.removeChild(textarea);
              }

              if (!result) {
                  return false;
              }
              
              return true;
        }
    }

    selectText(node: Node) {
        this.window.getSelection().selectAllChildren(node);
    }

    isInViewport(elem: HTMLElement): boolean {
        const bounding = elem.getBoundingClientRect();

        return bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= this.viewportHeight &&
            bounding.right <= this.viewportWidth;
    }

    ensureIsInView(elem: HTMLElement, partial: boolean = false) {
        if (!elem) {
            return;
        }

        const cont = this.getScrollParent(elem);
        if (!cont) {
            return;
        }

        const contTop = cont.scrollTop;
        const contBottom = contTop + cont.clientHeight;

        const elemTop = elem.offsetTop - elem.clientHeight;
        const elemBottom = elemTop + elem.clientHeight;

        if (elemTop < contTop) {
            cont.scrollTop = elemTop;
        } else if (elemBottom > contBottom) {
            cont.scrollTop += (elemBottom - contBottom);
        }
    }

    getScrollParent(elem: HTMLElement): HTMLElement {
        if (!elem) {
            return null;
        }
        
        return elem.scrollHeight > elem.clientHeight ? elem : this.getScrollParent(elem.parentElement);
    }
}
